<template>
  <!--  <div style="display:grid; grid-gap: 1em; justify-content:center; align-content: center; align-items: center; height: 100%; width: 100%;grid-template-columns: 1fr 1px 1fr; grid-template-rows: 100% ">-->
  <div class="hashersWrapper">
      <div class="hashersHeader">
          <div class="pageTitle"><localized-string val="runners.title"/></div>
          <input style="margin-left: 1em;" v-model="filter" placeholder="Search By Name" id="search"/>
      </div>
      <ag-grid-vue v-if="columnDefs"
                   style="width: 100%; height: 100%"
                   :enableFilter="false"
                   paginationAutoPageSize=true
                   :sortingOrder="['desc','asc']"
                   suppressCellSelection
                   animateRows
                   :pagination="true"
                   rowSelection="single"
                   class="ag-theme-material"
                   id="hasherGrid"
                   :columnDefs="columnDefs"
                   :rowData="tableData"
                   @first-data-rendered="onFirstDataRendered"
                   @grid-ready="onGridReady"
                   @row-selected="onRowSelected">
      </ag-grid-vue>
    </div>
</template>

<script>
  import strings from "../strings.js";
  import {AgGridVue} from "@ag-grid-community/vue";
  import HasherDao from "../daos/HasherDao";
  import LocalizedString from "../components/localizedString";
  export default {
    name: 'Hashers',
    components: {
      LocalizedString,
      AgGridVue
    },
    data: function () {
      return {
        selectedHasherId: null,
        hashers: null,
        filter: "",
      }
    },
    computed: {
      columnDefs: function() {
        if (!this.$strings["runners.table.name"]) {
          return null;
        } else {
          return [
            {headerName: this.$strings["runners.table.name"], field: 'hash_name', sortable: true, minWidth: 180, flex: 5},
            {headerName: this.$strings["runners.table.trailsRan"], field: 'trails_count', sortable: true, minWidth: 72, maxWidth: 144, flex: 1},
            {headerName: this.$strings["runners.table.trailsHared"], field: 'hares_count', sortable: true, sort: 'desc', minWidth: 72, maxWidth: 144, flex: 1}
          ];
        }
      },
      tableData: function () {
        if (!this.hashers || (this.hashers && this.hashers.length === 0)) {
          return undefined;
        } else {
          let hashersCopy = this.hashers.slice();
          hashersCopy.forEach(function (hasher) {
            hasher.hares_count = hasher.trails_hared.length;
            //TODO do this somewhere better
            hasher.trails_count = hasher.trails_ran.length + hasher.trails_hared.length;
          });
          return hashersCopy;
        }
      }
    },
    beforeMount: function () {
      var thisVue = this;
      this.hashers = [];
    },
    watch : {
      filter : {
        immediate: true,
        handler: function(filter) {
          //TODO : loading
          HasherDao.fetchAllWithFilter(filter).then(hashers => {
            //TODO test async out of order
            if (this.filter === filter) {
              this.hashers = hashers;
            }
          })
        }
      }
    },
    methods : {
      onGridReady: function(grid) {
        this.resizeColumns = grid.api.sizeColumnsToFit.bind(grid.api);
        this.resizeColumns();
        window.addEventListener('resize', this.resizeColumns);
      },
      onFirstDataRendered: function (grid) {
        this.resizeColumns();
        grid.api.getDisplayedRowAtIndex(0).setSelected(true, true);
      },
      onRowSelected: function(row) {
        if (row.node.isSelected()) {
          this.selectedHasherId = row.data.id;
        }
      }
    },
    beforeDestroy() {
      this.resizeColumns && window.removeEventListener('resize', this.resizeColumns);
    }
  }
</script>

<style lang="scss">
    /*#hasherGrid .ag-header-cell:not(:first-child) {*/
    /*    padding: 0;*/
    /*     text-align: center;*/
    /*}*/
    @media only screen and (max-width: 374px) {
        //Don't display up/down arrows on small screens
        #hasherGrid .ag-header-label-icon {
            display: none;
        }
    }
    #hasherGrid .ag-header-cell-label,
    #hasherGrid .ag-header-cell-label > .ag-header-cell-text {
        text-overflow: initial;
        overflow: visible;
        white-space: normal;
        line-height: initial;
    }
</style>
<style scoped lang="scss">
    .pageTitle {
        font-size: 36px;
        font-weight: 600;
        margin-bottom: 0.5em;
        text-align: center;
        width: 100%;
    }

    .hashersWrapper {
        max-width: 868px;
        background: rgba(255,255,255,0.95);
        display: flex;
        flex-direction: column;
    }

    .hashersHeader {
        //height: 50px;
        width: 100%;
        box-sizing: border-box;
        margin: 0.5em 0 1.5em 0;
    }

  @media only screen and (max-width: 600px) {
      .hashersWrapper {
          width: 100%;
          height: 100%;
          margin: 0;
      }
          #hasherDetail {

    }
    #hasherGrid {

    }
  }
  /*#hasherGrid  div {*/
  /*  overflow: visible !important;*/
  /*}*/
</style>

